import { render } from "./url.vue?vue&type=template&id=5524ccfe"
import script from "./url.vue?vue&type=script&lang=js"
export * from "./url.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__